<h2 mat-dialog-title>{{ mode === 'add' ? 'Adaugă Subsol' : 'Editare Subsol' }}</h2>

<mat-dialog-content>
    <form [formGroup]="form" class="footer-form">
        <!-- Nume -->
        <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Denumire</mat-label>
            <input matInput formControlName="name" placeholder="Ex: Subsol Standard cu Paginare">
            <mat-error *ngIf="form.get('name')?.hasError('required')">
                Denumirea este obligatorie
            </mat-error>
        </mat-form-field>

        <!-- Tip Conținut -->
        <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Tip Conținut</mat-label>
            <mat-select formControlName="content_type">
                <mat-option *ngFor="let type of contentTypes" [value]="type.value">
                    {{ type.label }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Text Content -->
        <div *ngIf="showTextContent" class="mb-3">
            <mat-form-field appearance="fill" class="w-100">
                <mat-label>Conținut Text (HTML)</mat-label>
                <textarea matInput formControlName="text_content" rows="3"
                    placeholder="Ex: Contact: contact@primaria4.ro"></textarea>
                <mat-hint>Puteți folosi HTML pentru formatare</mat-hint>
            </mat-form-field>
        </div>

        <!-- Image Upload -->
        <div *ngIf="showImageUpload" class="mb-3">
            <label class="form-label">Imagine Subsol</label>
            <div class="image-upload-area">
                <div *ngIf="previewImageUrl" class="image-preview mb-2">
                    <img [src]="previewImageUrl" alt="Preview" class="img-fluid">
                    <button type="button" mat-icon-button color="warn" class="remove-btn" (click)="removeImage()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
                <div *ngIf="!previewImageUrl" class="upload-placeholder">
                    <mat-icon>cloud_upload</mat-icon>
                    <span>Selectați o imagine</span>
                </div>
                <input type="file" accept="image/*" (change)="onFileSelected($event)" #fileInput hidden>
                <button type="button" mat-stroked-button (click)="fileInput.click()">
                    <mat-icon>upload</mat-icon>
                    {{ previewImageUrl ? 'Schimbă imaginea' : 'Încarcă imagine' }}
                </button>
            </div>
            <small class="text-muted">Format: JPG, PNG, GIF, SVG. Max 2MB.</small>
        </div>

        <!-- Aliniere -->
        <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Aliniere Conținut</mat-label>
            <mat-select formControlName="alignment">
                <mat-option *ngFor="let align of alignments" [value]="align.value">
                    {{ align.label }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Paginare Section -->
        <div class="pagination-section card mb-3">
            <div class="card-header">
                <mat-checkbox formControlName="show_pagination">
                    <strong>Afișează Paginare</strong>
                </mat-checkbox>
            </div>
            <div class="card-body" *ngIf="showPaginationOptions">
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Format Paginare</mat-label>
                            <mat-select formControlName="pagination_format">
                                <mat-option *ngFor="let format of paginationFormats" [value]="format.value">
                                    {{ format.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="fill" class="w-100">
                            <mat-label>Poziție Paginare</mat-label>
                            <mat-select formControlName="pagination_position">
                                <mat-option *ngFor="let align of alignments" [value]="align.value">
                                    {{ align.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="pagination-preview">
                    <small class="text-muted">Preview:</small>
                    <span class="badge bg-info">{{ paginationPreview }}</span>
                </div>
            </div>
        </div>

        <!-- Status Activ -->
        <div class="mb-3">
            <mat-checkbox formControlName="is_active">Activ</mat-checkbox>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" [disabled]="isLoading">Anulare</button>
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="isLoading || form.invalid">
        <mat-spinner *ngIf="isLoading" diameter="20" class="me-2"></mat-spinner>
        {{ mode === 'add' ? 'Adaugă' : 'Salvează' }}
    </button>
</mat-dialog-actions>
